import { root, subdomains } from "@/common/consts";

export default {
    data() {
        return {
            showLangMenu: false,
            languages: [
                { name: "English", url: `${root.WWW}/` },
                { name: "Español", url: `${root.ES}/` }
            ]
        };
    },
    methods: {
        openMobileMenu() {
            this.$emit("mobile-menu-toggle", true);
        },
        onWFMenuItemClick() {
            this.showLangMenu = !this.showLangMenu;
        },
        onWFMenuClickOutside() {
            this.showLangMenu = false;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher/LanguageSwitcher.js